module.exports = __webpack_public_path__ + "494cd07c/img/placeholder.888fcd0b.svg";